import produce from 'immer';

const initialState = {
  isValidToken: true,
  loading: false,
  message: null,
};

const FETCH_VALIDATE_TOKEN_REQUEST = 'FETCH_VALIDATE_TOKEN_REQUEST';
export const setFetchValidateTokenRequest = {
  type: FETCH_VALIDATE_TOKEN_REQUEST,
};

const FETCH_VALIDATE_TOKEN_SUCCESS = 'FETCH_VALIDATE_TOKEN_SUCCESS';
export const setFetchValidateTokenSuccess = (successMsg) => ({
  type: FETCH_VALIDATE_TOKEN_SUCCESS,
  payload: { successMsg },
});

const FETCH_VALIDATE_TOKEN_FAILURE = 'FETCH_VALIDATE_TOKEN_FAILURE';
export const setFetchValidateTokenFailure = (errorMsg) => ({
  type: FETCH_VALIDATE_TOKEN_FAILURE,
  payload: { errorMsg },
});

export const selectIsValidToken = ({ validateTokenReducer }) => validateTokenReducer?.isValidToken;

export default function validateTokenReducer(state = initialState, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case FETCH_VALIDATE_TOKEN_REQUEST:
        draft.loading = true;
        draft.message = null;
        break;
      case FETCH_VALIDATE_TOKEN_SUCCESS:
        draft.message = action.payload;
        draft.isValidToken = true;
        draft.loading = false;
        break;
      case FETCH_VALIDATE_TOKEN_FAILURE:
        draft.message = action.payload;
        draft.isValidToken = false;
        draft.loading = false;
        break;
      default:
        break;
    }
  });
}
